import { useState } from "react";
import TextHighlighter from "@/admin/atoms/TextHighlighter";
import { getViewArea } from "src/pages/api/user";
// import { KnowledgeBaseProp } from "src/services/dataTypeDefinition.type";
import KnowledgeBaseTab from "../KnowledgeBaseTab";
import { BtnVariant } from "../KnowledgeBaseTab/KnowledgeBaseTab";
import styles from "./KnowledgeBaseCourseManager.module.css";

// props: KnowledgeBaseProp
function KnowledgeBaseCourseManager(): JSX.Element {
  //  const { searchTerm } = props;
  const searchTerm = "";

  const [btnList, setBntList] = useState<BtnVariant[]>([
    {
      title: "Create Course",
      bntActive: true,
    },
    {
      title: "Add Module",
      bntActive: false,
    },
    {
      title: "Add Quiz",
      bntActive: false,
    },
    {
      title: "View Modules",
      bntActive: false,
    },
    {
      title: "Edit Course",
      bntActive: false,
    },
    {
      title: "Edit Module",
      bntActive: false,
    },
    {
      title: "Delete Course",
      bntActive: false,
    },
    {
      title: "Delete Module",
      bntActive: false,
    },
  ]);

  const switchState = (index2: number) => {
    setBntList(
      btnList.map((btnObject, index) => {
        if (index === index2) {
          return {
            title: btnObject.title,
            bntActive: true,
          };
        }
        return {
          title: btnObject.title,
          bntActive: false,
        };
      })
    );
  };
  return (
    <div className={styles.frame}>
      <div className="font-bold text-[24px] text-[#262626]">COURSE MANAGER</div>
      <div className=" text-[#434343]">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="The Course Manager feature contains such functionalities as adding
        courses to your training programme, adding modules to courses and adding
        quizzes."
          id="courseManagerText1"
        />
      </div>

      <div>
        <KnowledgeBaseTab
          btnList={btnList}
          callBack={switchState}
          getViewArea={getViewArea}
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabCreateCourse"
      >
        Create Course
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/create-course.svg"
        alt="create course"
        className="mt-4"
      />

      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='This is the default screen that appears if no course has been created.
        To create a new course, select the 
        <span style="font-weight: bold;">“Create Course”</span> tab under the Course
        Manager feature and click on the 
        <span style="font-weight: bold;">“Create Course”</span> button'
          id="courseManagerText2"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/create-course2.svg"
        alt="create course"
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='After clicking on the <span style="font-weight: bold;">“Create Course”</span>
        button this screen appears where you will need to input the course
        details. Input the Course name, the User Group, the Cover Image and the Course Description. Having done this, click 
        <span style="font-weight:bold;">"Save & Add Module"</span>'
          id="courseManagerText3"
        />
      </div>

      <div className=" text-[#434343] font-bold mt-4">PLEASE NOTE:</div>

      <div id="userText6">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='<ul style="list-style-type: disc; padding-left: 40px;">
              <li>
                Tenants who are operating a Trial account can only create two courses. An upgrade to Premium will be required for full access. 
              </li>
              <li>
                Clicking the <span style="font-weight:bold;">“Save”</span> button here means you are not adding any module to the course at the moment. You can always return to edit the course and add a module to it. 
              </li>
              <li>
               Courses with no module added to them will not be published: they will not be visible on the learners’ side until a module is added.
              </li>
              <li>
               After creating your courses, you can reorder the courses by dragging and dropping the course you wish to reorder on the <span style="font-weight:bold;">“All Courses”</span> screen. 
              </li>
              
            </ul>'
          id="userManagerText61aed"
        />
      </div>

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabAddModule"
      >
        Add Module
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/add-module.svg"
        alt="add module"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To add a Module, click on the 
        <span style="font-weight: bold;">“Save & Add Module”</span> button while
        creating a course. This will save the Course you are creating and bring
        you to the <span style="font-weight: bold;">“Add Module Screen”</span>.'
          id="courseManagerText4"
        />
      </div>

      <img
        src="/images/knowledgebase-images/svgs/course-library/add-module2.svg"
        alt="add module"
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='On the <span style="font-weight: bold;">“Add Module”</span> screen Select if
        you want to add a <span className="font-bold">“module Only”</span> or
        add a <span style="font-weight: bold;">“Module with Task”</span>. After
        making your selection, click 
        <span style="font-weight: bold;">“Continue”</span>.'
          id="courseManagerText5"
        />
      </div>
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='If you choose <span style="font-weight:bold;">“Module Only”</span> you will be brought to the <span style="font-weight:bold;">“Add Module Details”</span> screen 
          where you will have to input the module details. After inputting the Module details,
           click <span style="font-weight:bold;">“Next: Add Content”</span>.'
          id="courseManagerText5a"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/add-module3.svg"
        alt="add module"
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="After selecting your Course Module Preference you will be brought to 
          the “Add Module Details” screen where you will have to input the module details. 
          After inputting the Module details, click “Next: Add Content”. If you selected “Module with Task”, 
          click the “Next: Add Task & Content” button."
          id="courseManagerText6"
        />
      </div>

      <div className=" text-[#434343] font-bold mt-4">PLEASE NOTE:</div>

      <div id="userText6">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="<ul style='list-style-type: disc; padding-left: 40px;>
              <li>
                The position of each module will be in the order in which they were created. In a case where you wish to change the order of a module kindly navigate to the Modules screen and drag and drop the module you wish to reorder.
              </li>
              <li>
                Users will have to complete one module before moving to the next. 
              </li>
            </ul>"
          id="userManagerText61a3"
        />
      </div>

      <img
        src="/images/knowledgebase-images/svgs/course-library/add-module4.svg"
        alt="add module"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="Next, you will be taken to the Module Content screen where you will have
        to input the content of the module you are currently creating. Here, you
        will need to upload the file which you want to add to your module which
        can be a video, a document, a PDF or any other file with supported
        format."
          id="courseManagerTex7"
        />

        <br />
        <div className="mt-4" />
        <TextHighlighter
          searchValue={searchTerm}
          textContent='You can choose to attach a quiz to your module to test users and ensure
        that they have gained sufficient knowledge before moving to the next
        module. To attach a quiz, toggle 
        <span style="font-weight: bold;">“Add quiz”</span> on.'
          id="courseManagerTex8"
        />

        <br />

        <div className="mt-4" />

        <TextHighlighter
          searchValue={searchTerm}
          textContent='If you do not wish to add a quiz, click on the 
        <span style="font-weight: bold;">“Save”</span> button when you are done with
        inputting your module content to save the module or click on 
        <span style="font-weight: bold;">“Save and Add Another Module”</span> to save
        the module you are currently creating and create another module. If you
        wish to add a quiz, please refer to the next step.'
          id="courseManagerTex9"
        />
      </div>

      <div className=" text-[#434343] font-bold mt-4">PLEASE NOTE:</div>
      <ul>
        <li>
          Tenants who are operating a Trial account can only add three modules
          each to courses and each module can have a maximum of two tasks each.
          An upgrade to Premium will be required for full access.
        </li>
      </ul>

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabAddQuiz"
      >
        Add Quiz
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/add-quiz1.svg"
        alt="add quiz"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='When you toggle <span style="font-weight: bold;">“Add Quiz”</span> on, more
        fields will show up at the bottom of the screen where you will have to
        fill in the quiz duration and pass mark and add the quiz questions.'
          id="courseManagerText10"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/add-quiz2.svg"
        alt="add quiz"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='When you click on the <span style="font-weight: bold;">“Add Question”</span> 
        button, this pop-up overlays the screen where you will need to input the
        quiz content, select the question type, add your question, include the
        options and indicate the correct answer. When you are done with this,
        click <span style="font-weight: bold;">“Save and Add Another Question”</span> 
        to add another question or click 
        <span style="font-weight: bold;">“Save”</span> if you are done adding all the
        questions in the quiz.'
          id="courseManagerText11"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/add-quiz3.svg"
        alt="add quiz"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='When you are done adding your quiz questions, you will be brought back
        to the Module Content page where you will need to click 
        <span className="mt-4" style="font-weight: bold;">“Save”</span> to save the quiz in the module.'
          id="courseManagerText12"
        />

        <br />
        <div className="mt-4" />
        <TextHighlighter
          searchValue={searchTerm}
          textContent="Please note: Users will have to complete one module before moving to the
          next"
          id="courseManagerText13"
        />
      </div>

      <img
        src="/images/knowledgebase-images/svgs/course-library/add-quiz4.svg"
        alt="add quiz"
        className="mt-4"
      />

      <div className="w-full mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="After clicking on the save button you will need to input the Course Publish Settings. Here you will confirm the user Groups and input the estimated course duration. After this is done, click <span style='font-weight: bold;'>“Complete”</span>. "
          id="courseManagerText13a"
        />
      </div>

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabViewCourses"
      >
        View Courses
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/view-course.svg"
        alt="view course"
        className="mt-4"
      />

      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To view all courses, click on the 
        <span style="font-weight: bold;">“All Courses”</span> tab by the top
        left-hand corner of the screen.'
          id="courseManagerText14"
        />

        <br />
        <div className="mt-2" />
        <TextHighlighter
          searchValue={searchTerm}
          textContent='You can create a new course from this screen by clicking the 
        <span style="font-weight: bold;">“Create Course”</span> button at the top
        right-hand corner of your screen.'
          id="courseManagerText15"
        />

        <br />
        <div className="mt-2" />
        <TextHighlighter
          searchValue={searchTerm}
          textContent="You can search for a course using the search bar at the top of your
        screen."
          id="courseManagerText16"
        />
      </div>

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabEditCourse"
      >
        Edit Course
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/edit-course.svg"
        alt="view module"
        className="mt-4"
      />

      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To edit a course, click on the three dots next to the course in the <span style="font-weight: bold;">“All Courses”</span> screen, then click edit.'
          id="courseManagerText17a1"
        />
      </div>

      <img
        src="/images/knowledgebase-images/svgs/course-library/edit-course2.svg"
        alt="view module"
        className="mt-10"
      />
      <div className="w-full  mt-4">
        This will take you to the course details page where you can edit your
        course details. When you are done with your edits, click “Save Changes”
        and your edit will be updated. You can also save the changes made and
        add a module to the course by clicking on “Save Changes & Add Module”.
      </div>

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabViewModules"
      >
        View Module
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/view-module.svg"
        alt="view module"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To view modules under a course, select the course in the
            <span style="font-weight: bold;">“All Courses”</span> screen.'
          id="courseManagerText18"
        />
        <br />
        <div className="mt-4" />

        <TextHighlighter
          searchValue={searchTerm}
          textContent='You can create new modules by clicking on the
        <span style="font-weight: bold;">“Create Module”</span> button at the top
        right-hand corner of your screen. You can also search for modules by
        clicking on the search bar at the top of your screen'
          id="courseManagerText19"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/view-module2.svg"
        alt="view module"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='If no module has been added yet to the selected task, this screen
        appears. You can click on the
        <span style="font-weight: bold;">“Add Module”</span> button to add a module
        to the task.'
          id="courseManagerText20"
        />
      </div>
      {/* 
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabEditCourse"
      >
        Edit Course
      </div>
      <img
        src="/images/knowledgebase-images/course-manager/edit-course1.svg"
        alt="edit course"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To edit a course, click on the three dots next to the` course in the
        <span className="font-bold">“All Courses”</span> screen, then click
        edit.'
          id="courseManagerText21"
        />
      </div>
      <img
        src="/images/knowledgebase-images/course-manager/edit-course2.svg"
        alt="edit course"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='This will take you to the course details page where you can edit your
        course details. When you are done with your edits, click
        <span className="font-bold">“Save Changes”</span> and your edit will be
        updated. You can also save the changes made and add a module to the
        course by clicking on
        <span className="font-bold">“Save Changes & Add Module”</span>.'
          id="courseManagerText22"
        />
      </div> */}
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabEditModule"
      >
        Edit Module
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/edit-module.svg"
        alt="edit module"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="To edit a module, click on the edit icon next to the module on the
        Modules screen."
          id="courseManagerText23"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/edit-module2.svg"
        alt="edit module"
        className="mt-4"
      />
      <img
        src="/images/knowledgebase-images/svgs/course-library/edit-module3.svg"
        alt="edit module"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='You will be taken to the Module details screen where you can edit the
        Module details or switch tabs to edit the Module Task and content. When
        you&#39;re done with your edits, click 
        <span style="font-weight: bold;">“Save Changes”</span> to save the changes
        you have made.'
          id="courseManagerText24"
        />

        <br />
        <div className="mt-4" />
        <TextHighlighter
          searchValue={searchTerm}
          textContent='You can also delete a module from this screen by clicking on the
        <span style="font-weight: bold;">“Delete”</span> button at the bottom left.'
          id="courseManagerText25"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabDeleteCourse"
      >
        Delete Course
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/delete-course.svg"
        alt="delete course"
        className="mt-4"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To delete a course, click on the three dots next to the course on the
        <span style="font-weight: bold;">“All Courses”</span> screen, then click
        <span style="font-weight: bold;">“Delete”</span>.'
          id="courseManagerText26"
        />
      </div>
      <div className="font-bold">PLEASE NOTE:</div>

      <TextHighlighter
        searchValue={searchTerm}
        textContent='<ul style="list-style-type: disc; padding-left: 40px;">
        <li>
          When a course is deleted all modules, content, user progress, and quiz
          attached to it will also be deleted automatically.
        </li>
        <li>
          In a case where a course is deleted by mistake, you can reach out to
          our customer support handles via WhatsApp on
          <span className="text-[#4856DD]">+44 7404 036868</span> or via email
          at <span className="text-[#4856DD]">support@crestagile.com</span> to
          have the course retrieved from our database.
        </li>
        <li>
          Upon retrieving a previously deleted course, user progress on the
          course will not be restored.
        </li>
      </ul>'
        id="courseManagerText27"
      />

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabDeleteModule"
      >
        Delete Module
      </div>
      <img
        src="/images/knowledgebase-images/svgs/course-library/delete-module.svg"
        alt="delete module"
        className="mt-4"
      />

      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="To delete a module, click on the delete icon next to the module you wish
        to delete."
          id="courseManagerText28"
        />
      </div>
      <div className="font-bold">PLEASE NOTE:</div>
      <TextHighlighter
        searchValue={searchTerm}
        textContent='<ul style="list-style-type: disc; padding-left: 40px;">
        <li>
          When a module is deleted all content, user progress, and quiz attached
          to it will also be deleted automatically
        </li>
        <li>
          In a case where a module is deleted by mistake, you can reach out to
          our customer support handles via WhatsApp on
          <span style="color:#4856DD;">+44 7404 036868</span> or via email
          at <span style="color: #4856DD;">support@crestagile.com</span> to
          have the module retrieved from our database.
        </li>
        <li>
          Upon retrieving a previously deleted module, user progress on the
          module will not be restored.
        </li>
      </ul>'
        id="courseManagerText29"
      />
    </div>
  );
}

export default KnowledgeBaseCourseManager;
